import { functions } from "@/main";
import { MiraCompany, MiraCompanySave } from "../models/MiraCompanyAdministration";

/**
 * The companies of Mira's market comparison in the IRES Admin Client, through IRES Cloud
 * (`MiraCompaniesForAdministration.ts`, documented in Cloud `functions/docs/analytics/mira-precompute.md`).
 * Each callable has a `…Development` twin; swap to it **locally only** to drive the twin from a dev
 * server, never commit the swap.
 */
const LIST_CALLABLE = "listMiraCompaniesForAdministration";
const SAVE_CALLABLE = "saveMiraCompanyForAdministration";

/** Every company, retired ones included. `MANAGE_CLIENTS`. */
export async function listMiraCompanies(): Promise<MiraCompany[]> {
  const data = (await functions.httpsCallable(LIST_CALLABLE)()).data as { companies?: unknown } | null;
  return Array.isArray(data?.companies) ? (data?.companies as MiraCompany[]) : [];
}

/** Creates or edits one company. Rejects with `details.reason` (CONFLICT, CHANGED_MEANWHILE, NO_CLIENT, ...). */
export async function saveMiraCompany(save: MiraCompanySave): Promise<MiraCompany> {
  const data = (await functions.httpsCallable(SAVE_CALLABLE)(save)).data as { company?: MiraCompany } | null;
  if (!data?.company) {
    throw new Error("The save response carried no company.");
  }
  return data.company;
}
